import createIcon from '../../createIcon';

/**
 * @component @name Onetwothree
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy4yNSAxNUg1Ljc1VjEwLjVINC4yNVY5SDcuMjVWMTVaTTEzLjc1IDEzLjVIMTAuNzVWMTIuNUgxMi43NUMxMy4zIDEyLjUgMTMuNzUgMTIuMDUgMTMuNzUgMTEuNVYxMEMxMy43NSA5LjQ1IDEzLjMgOSAxMi43NSA5SDkuMjVWMTAuNUgxMi4yNVYxMS41SDEwLjI1QzkuNyAxMS41IDkuMjUgMTEuOTUgOS4yNSAxMi41VjE1SDEzLjc1VjEzLjVaTTE5Ljc1IDE0VjEwQzE5Ljc1IDkuNDUgMTkuMyA5IDE4Ljc1IDlIMTUuMjVWMTAuNUgxOC4yNVYxMS41SDE2LjI1VjEyLjVIMTguMjVWMTMuNUgxNS4yNVYxNUgxOC43NUMxOS4zIDE1IDE5Ljc1IDE0LjU1IDE5Ljc1IDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Onetwothree = createIcon('Onetwothree', [
  [
    'path',
    {
      d: 'M7.25 15H5.75V10.5H4.25V9H7.25V15ZM13.75 13.5H10.75V12.5H12.75C13.3 12.5 13.75 12.05 13.75 11.5V10C13.75 9.45 13.3 9 12.75 9H9.25V10.5H12.25V11.5H10.25C9.7 11.5 9.25 11.95 9.25 12.5V15H13.75V13.5ZM19.75 14V10C19.75 9.45 19.3 9 18.75 9H15.25V10.5H18.25V11.5H16.25V12.5H18.25V13.5H15.25V15H18.75C19.3 15 19.75 14.55 19.75 14Z',
      key: '8c9t56',
    },
  ],
]);

export default Onetwothree;
